import React, { memo } from 'react';
import { useScreenLayout } from 'common-ui';
import type { ImageEntryType } from 'tsconfig/types';
import type { Config as ReactPlayerConfig } from 'react-player/lazy';
import VimeoReactPlayer from './VimeoReactPlayer';
import YouTubeIframePlayer from './YouTubeIframePlayer';
import { globals } from '../../utils/globals';

export type VideoPlayerProps = {
  videoLink: string;
  config?: ReactPlayerConfig;
  showThumbnail?: boolean;
  image?: ImageEntryType;
  onPlayPause?: () => void;
  onReadyFn?: (iframe: HTMLIFrameElement | null) => void;
  smallDeviceVideoLink?: string;
  className?: string;
  testId?: string;
  loop?: boolean;
  width?: string;
  height?: string;
  controls?: boolean;
  lazy?: boolean;
};

function VideoPlayer(props: Readonly<VideoPlayerProps>) {
  const {
    config,
    showThumbnail,
    image,
    onPlayPause,
    onReadyFn,
    videoLink,
    smallDeviceVideoLink,
    className,
    testId,
    loop,
    width,
    height,
    controls,
    lazy,
  } = props;

  const { isNotDesktop } = useScreenLayout();

  const url = isNotDesktop ? smallDeviceVideoLink || videoLink : videoLink;
  const isYouTube = /youtu(be\.com|\.be|be-nocookie\.com)/.test(url);

  if (isYouTube && globals.country === 'uk') {
    return (
      <YouTubeIframePlayer
        url={url}
        showThumbnail={showThumbnail}
        image={image}
        onPlayPause={onPlayPause}
        onReadyFn={onReadyFn}
        className={className}
        testId={testId}
        loop={loop}
        width={width}
        height={height}
        controls={controls}
        lazy={lazy}
      />
    );
  }

  return (
    <VimeoReactPlayer
      url={url}
      showThumbnail={showThumbnail}
      image={image}
      onPlayPause={onPlayPause}
      onReadyFn={onReadyFn}
      className={className}
      testId={testId}
      loop={loop}
      width={width}
      height={height}
      controls={controls}
      config={config}
    />
  );
}

export default memo(VideoPlayer);
